import { createSlice } from '@reduxjs/toolkit';
import { getParsedLSItemOr } from 'utils.js';
import API from 'api/index.js';

const initialState = {
    shopId: getParsedLSItemOr('shopId', null, true),
    shopName: localStorage.shopName ?? null,
    shops: null, // `null` until data is received without errors. afterwards Shop[]
    hasAccessToBatteryForm: null,
};

export const operatorHomeSlice = createSlice({
    name: 'operatorHome',
    initialState,
    reducers: {
        deselectShop: state => {
            localStorage.removeItem('shopId');
            localStorage.removeItem('shopName');
            state.shopId = null;
            state.shopName = null;
        },
        selectShop: (state, { payload }) => {
            const shopName = state.shops?.find(({ id }) => id === payload)?.name ?? null;

            state.shopId = payload;
            localStorage.shopId = payload;

            state.shopName = shopName;
            localStorage.shopName = shopName;
        },
    },
    extraReducers: builder => {
        const { shopList, operatorQuestionnaire } = API.endpoints;

        builder
            .addMatcher(shopList.matchFulfilled, (state, { payload }) => { state.shops = payload; })
            .addMatcher(operatorQuestionnaire.matchFulfilled, state => { state.hasAccessToBatteryForm = true; });
    },
});

export const { deselectShop, selectShop } = operatorHomeSlice.actions;

export default operatorHomeSlice.reducer;
